import Router from 'next/router';
import { useEffect } from 'react';
import { dig } from '../../helpers/dig';
import { completeBooking } from './helpers';
import { analyticsClient } from '../../client/analytics';
import { identify } from '../../client/segment';

export default function ChiliPiperWidget({ enrichResults, values, qualification }) {
  const fullName = encodeURI(dig(enrichResults, 'person', 'name', 'fullName') || '');
  const linkedinHandle = dig(enrichResults, 'person', 'linkedin', 'handle');
  const linkedinUrl = linkedinHandle ? encodeURI(`www.linkedin.com/${linkedinHandle}`) : '';

  useEffect(() => {
    const messageListener = (e) => {
      if (e.data.action === 'booking-confirmed') {
        completeBooking(qualification, false);
        analyticsClient.track('Chili Piper booked', {
          fullName,
          email: values.email,
          domain: values.domain,
          linkedinUrl,
        });
        identify(values.email, {
          email: values.email,
          calendly_booked: 'true',
        });
        analyticsClient.identify(values.email, {
          email: values.email,
          calendly_booked: 'true',
        });
        setTimeout(() => Router.push('/community'), 5000);
      }
    };

    if (!values.email) {
      window.location.reload();
    } else {
      window.ChiliPiper.submit('mutinyhq', 'mutiny-personalization-strategy-call', {
        domElement: '#chili-piper-container',
        lead: {
          firstname: fullName.split(' ')[0] || '',
          lastname: fullName.split(' ')[1] || '',
          email: values.email,
        },
      });
    }

    window.addEventListener('message', messageListener);
    return () => window.removeEventListener('message', messageListener);
  }, []);
  return <div id="chili-piper-container" className="BookingWidget" />;
}
